import Repository from "./Repository";
import store from "../store";

const resource = "/SupplierCategory";

export default {
  listBySupplierId(supplierId, page, itemsPerPage) {
    return Repository.get(
      `${resource}/by-supplier-id/${supplierId}/${page}/${itemsPerPage}`
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getSubcategoriesBySupplierCategoryId(categoryId, page, itemsPerPage) {
    return Repository.get(
      `${resource}/subcategories/${categoryId}/${page}/${itemsPerPage}`
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getSimilarCategories(categoryId) {
    return Repository.get(`${resource}/similar-categories/${categoryId}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getCategoriesForSelect() {
    return Repository.get(`${resource}/categories-for-select`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  saveCategoryRelation(categoryRelation) {
    return Repository.post(
      `${resource}/save-category-relation`,
      categoryRelation
    )
      .then((response) => {
        store.commit("setSnack", {
          message: "Изменения сохранены",
          color: "success",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getSupplierCategory(categoryId) {
    return Repository.get(`${resource}/supplier-category/${categoryId}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  saveCategoryProperties(props, supplierId, categoryId) {
    return Repository.post(
      `${resource}/save-categories-properties/${supplierId}/${categoryId}`,
      props
    )
      .then((response) => {
        store.commit("setSnack", {
          message: "Изменения сохранены",
          color: "success",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  addNewCategory(category) {
    return Repository.post(`${resource}/add-new-category`, category)
      .then((response) => {
        store.commit("setSnack", {
          message: "Категория добавлена",
          color: "success",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
